import { useStaticQuery, graphql } from "gatsby"
// TODO: PERCHÉ WHY?
export const useUsersGraphql = () => {
  const { www } = useStaticQuery(
    graphql`
        query getUsers {
            www {
                users(
                    first: 1000,
                    where: {orderby: {field: DISPLAY_NAME, order: ASC}}
                    ) {
                    nodes {
                    id
                    name
                    userId
                    slug
                    description
                        avatar {
                            foundAvatar
                            url
                        }
                    }
                }
            }
        }`
    )
    return www
}